import { Article } from "@phosphor-icons/react";
import { useParams } from "react-router-dom";

import { AddExploreSubSectionForm } from "@/components/Explore/Forms/AddExploreSubSectionForm";
import type { ModalProps } from "@/shared.types";
import { Circle, Heading, Modal } from "@/ui";

// Modal for adding a new article to an Explore section
// Gets the section ID from URL params
export const AddExploreSubSectionModal = ({ show, onClose }: ModalProps) => {
  const { sectionId } = useParams<{ sectionId: string }>();

  if (!sectionId) {
    return null;
  }

  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading="Add New Article"
            left={
              <Circle>
                <Article size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">*Required fields</span>
        </div>
      }
      onClose={onClose}
    >
      <AddExploreSubSectionForm sectionId={sectionId} onClose={onClose} />
    </Modal>
  );
};
